/** ============================================================= *
 *  ---------------------- IMPORT - START ----------------------- *
 *  ============================================================= */
import 'what-input'
import jQuery from 'jquery'
import Foundation from 'foundation-sites'
import intlTelInput from 'intl-tel-input/intlTelInputWithUtils'
import 'owl.carousel'
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import { setHrefs } from './functions/data-hrefs'
import { initEqualizeContent } from './functions/equalizer'
import { initTelephoneInput } from './functions/intl-tel-input'
import { initDatepickerInput } from './functions/datepicker'
import { enableNegativeMargins } from './functions/negative-margins'
import { mapStyles } from './functions/map-styles'
/** ============================================================= *
 *  ----------------------- IMPORT - END ------------------------ *
 *  ============================================================= */



/** ============================================================= *
 *  ------------ GLOBAL VARIABLES DECLARATION - START ----------- *
 *  ============================================================= */
const THEME_FOLDER = "../wp-content/themes/codesm_wp_foundation"
const PHONE_FIELD = ".codesm-phone-field"
const DATEPICKER_FIELD = ".codesm-datepicker-field"
const DATEPICKER_FORMAT = "mm/dd/yyyy"
const EQUALIZE_CONTENT = ".codesm-equalize-content"

Foundation.addToJquery(jQuery)
Swiper.use([Navigation, Pagination, Autoplay])
window.intlTelInput = intlTelInput
window.setHrefs = setHrefs
window.initEqualizeContent = initEqualizeContent
window.initTelephoneInput = initTelephoneInput
window.initDatepickerInput = initDatepickerInput
window.enableNegativeMargins = enableNegativeMargins
window.mapStyles = mapStyles
// window.enableCallrailTracking = enableCallrailTracking
/** ============================================================= *
 *  ------------- GLOBAL VARIABLES DECLARATION - END ------------ *
 *  ============================================================= */



jQuery(document).ready(function () {
	jQuery(document).foundation();
	triggerThemeFunctions();

	const navLinks = document.querySelectorAll('#offcanvas-nav a');
	const closeBtn = document.getElementById('off-canvas-close');

	navLinks.forEach(link => {
		link.addEventListener('click', () => {
			// Don't close if this link toggles a submenu
			if (link.closest('li') && link.closest('li').querySelector('ul')) {
				return;
			}
			// Only trigger if the close button exists
			if (closeBtn) {
				closeBtn.click();
			}
		});
	});

	// Sticky Header Background Change on Scroll
	jQuery(window).on('scroll', function () {
		if (jQuery(this).scrollTop() > 50) {
			jQuery('header.header').addClass('is-sticky');
		} else {
			jQuery('header.header').removeClass('is-sticky');
		}
	});

	var logo = new Swiper('#client-logo .swiper-container', {
		direction: 'horizontal',
		slidesPerView: 3,
		slidesPerColumn: 1,
		spaceBetween: 30,
		autoplay: {
			delay: 3000,
		},
		pagination: {
			el: '#client-logo .swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
		loop: false,
		centeredSlides: true,
		watchSlidesVisibility: true,
		observer: true,
		observeParents: true,
		breakpoints: {
			640: {
				slidesPerView: 1,
			},
			1024: {
				slidesPerView: 2,
			},
			1200: {
				slidesPerView: 3,
			},
			1440: {
				slidesPerView: 3,
			},
		},
		on: {
			init: function () {
				setTimeout(function () {
					window.dispatchEvent(new Event('resize'));
				}, 500);
			},
		},
	});

	// Number Counter Animation
	const counters = document.querySelectorAll('.number-counter');
	const animateCounter = (el) => {
		const text = el.innerText;
		const numberMatch = text.match(/[\d.]+/);
		if (!numberMatch) return;

		const target = parseFloat(numberMatch[0]);
		const prefix = text.substring(0, text.indexOf(numberMatch[0]));
		const suffix = text.substring(text.indexOf(numberMatch[0]) + numberMatch[0].length);
		const duration = 2000;
		const startTime = performance.now();
		const isDecimal = numberMatch[0].includes('.');
		const decimalPlaces = isDecimal ? numberMatch[0].split('.')[1].length : 0;

		const step = (currentTime) => {
			const progress = Math.min((currentTime - startTime) / duration, 1);
			const easeOutQuad = 1 - (1 - progress) * (1 - progress);
			const current = target * easeOutQuad;
			el.innerText = prefix + (isDecimal ? current.toFixed(decimalPlaces) : Math.floor(current)) + suffix;
			if (progress < 1) {
				requestAnimationFrame(step);
			} else {
				el.innerText = prefix + numberMatch[0] + suffix;
			}
		};
		requestAnimationFrame(step);
	};

	const counterObserver = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				animateCounter(entry.target);
				observer.unobserve(entry.target);
			}
		});
	}, { threshold: 0.5 });

	counters.forEach(counter => counterObserver.observe(counter));


	document.querySelector('form.wpcf7-form').addEventListener('submit', function(e){
		var sel = document.getElementById('referral-source-select');
		var inp = document.querySelector('input[name="referral-names"]');
		if(sel && sel.value === 'Referrals' && inp && !inp.value.trim()){
			e.preventDefault();
			alert('Please enter the name(s) of the person(s) who referred you.');
		}
	});
});



/** ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= *
 *  ----------------- THEME FUNCTIONS - START ------------------- *
 *  ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= */
function triggerThemeFunctions() {
	// REMOVE EMPTY P TAGS CREATED BY WP INSIDE OF ACCORDION AND ORBIT
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// ADD FLEX VIDEO TO YOUTUBE AND VIMEO EMBEDS
	jQuery(':not(.responsive-embed):not(.flex-video)>iframe[src*="youtube.com"], :not(.responsive-embed):not(.flex-video)>iframe[src*="vimeo.com"]').each(function () {
		if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// ENABLE PSEUDO ELEMENTS FOR FONT AWESOME
	window.FontAwesomeConfig = {
		searchPseudoElements: true
	};

	// DISABLE FIRST OPTION
	jQuery('select.disable-first-option').each(function () {
		jQuery(this).find('option').first().attr('disabled', 'disabled');
	});

	// HANDLE DATA-HREF
	window.setHrefs();

	// TRIGGER EQUALIZER
	window.initEqualizeContent(EQUALIZE_CONTENT);

	// INTL-TEL-INPUT
	window.initTelephoneInput(PHONE_FIELD, THEME_FOLDER);

	// ENABLE NEGATIVE MARGINS
	window.enableNegativeMargins();

	// FOUNDATION DATEPICKER
	window.initDatepickerInput(DATEPICKER_FIELD, DATEPICKER_FORMAT);

	// // ENABLE CALLRAIL TRACKING
	// window.enableCallrailTracking();
}
/** ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= *
 *  ------------------ THEME FUNCTIONS - END -------------------- *
 *  ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= */